import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import StockService from "../../Api_Module/Api_Services/StockService";
import { useParams } from "react-router-dom";
import MarketDummy from "./MarketDummy";
import moment from "moment";


const MarketTrend = () => {
    const { symbol } = useParams<{ symbol?: string }>();
    // const [selectedMetrics, setSelectedMetrics] = useState([] as any[]);
    const [selectedPeriod, setSelectedPeriod] = useState<string>("annual");
    const [periods, setPeriods] = useState<any>([]);
    const year = 5;
    const [seriesData, setSeriesData] = useState<ChartData>({
        series: [],
        yAxis: []
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    useEffect(() => {
        if (periods.length === 0)
            fetchMetricsData();
    }, [symbol, periods.length]);

    useEffect(() => {
        if (selectedPeriod) {
            fetchMetricsData();
        }
    }, [selectedPeriod]);

    const fetchMetricsData = async () => {
        try {
            setIsLoading(true);
            setSeriesData({
                series: [],
                yAxis: []
            });
            const result = await StockService.getCompanyPerformanceSnapshot(symbol, selectedPeriod);
            console.log("Fetched Metrics Data:", result);
            if (result && result.metrics && result.time_periods) {
                let metricKeys = Object.keys(result?.metrics || {}).map((key: string) => {
                    return {
                        key,
                        label: key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
                    };
                }).filter((item: any) => item !== undefined);

                metricKeys.push({
                    key: 'share_price',
                    label: 'Share Price'
                });
                const share_price = result?.share_price.sort((a: any, b: any) => moment(a.date).diff(moment(b.date))) || [];
                // setSelectedMetrics(metricKeys);
                let metricData = result?.metrics || {};
                metricData.share_price = result?.share_price || [];
                let series: any = [];
                let yaxisData: any = [];
                yaxisData.push({
                    title: {
                        enabled: true,
                        text: ``,
                    },
                    labels: {
                        enabled: true,
                        formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): any {
                            return  '$' + this.value;
                        },
                        style: {
                            color: '#9CA3AF',
                        },
                    },
                    opposite: false,
                    gridLineColor: 'transparent',
                });
                
                yaxisData.push({
                    title: {
                        enabled: true,
                        text: '',
                    },
                    labels: {
                        enabled: true,
                        formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): any {
                            return this.value + '%';
                        },
                        style: {
                            color: '#8B5CF6',
                        },
                    },
                    opposite: true,
                    gridLineColor: 'transparent',
                });

                const allPeriods = new Set<string>();
                result.time_periods?.forEach((v: any) => {
                    allPeriods.add(v);
                });
                const sortedPeriods = Array.from(allPeriods);
                setPeriods(sortedPeriods);
                metricKeys?.map((metric: any) => {
                    if (metric.key === 'share_price') {
                        series.push({
                            name: metric.label,
                            type: 'line',
                            yAxis: 0,
                            xAxis: 1 ,
                            label: 'share_price',
                            data: share_price?.filter((v: any) => moment(v.date).isAfter(moment().subtract(year, 'years')))?.map((v: any) => { return { x: new Date(v.date).getTime(), y: v.close || 0, label: 'share_price' }; }) || [],
                            tooltip: {
                                valuePrefix: '$',
                                valueSuffix: '',
                            } as any,
                        });
                    } else {
                        const metricData = result?.metrics[metric.key] || [];
                        const dataMap = new Map();
                        metricData.forEach((v: any) => {
                            // if(v.period === "TTM") {
                            //     dataMap.set("TTM", parseFloat(v.value.replace("%", "")) || 0);
                            // }else{
                                // const year = new Date(v.period).getFullYear();
                                dataMap.set(v?.period, parseFloat(v.value.replace("%", "")) || 0);
                            // }
                            
                        });
                        
                        const seriesData = sortedPeriods.map((timestamp, idx) => ({x: idx, y: dataMap.get(timestamp), label: metric.label}));
                        series.push({
                            name: metric.label,
                            type: 'column',
                            yAxis: 1,
                            label: metric.key,
                            data: seriesData,
                            tooltip: {
                                valuePrefix: '',
                                valueSuffix: '%',
                            } as any,
                        });
                    }
                });
                setSeriesData({ series, yAxis: yaxisData });
            }
        } catch (error) {
            console.error('Error fetching metrics data:', error);
        } finally {
            setIsLoading(false);
        }
    }
    const handlePeriodChange = (period: string) =>{
        setSelectedPeriod(period);
    }

    return (
        <div className="rounded-md overflow-hidden bg-transparent border-none">
            {isLoading ? (
                <div className="flex items-center justify-center h-96">
                    <div className="flex flex-col items-center space-y-3">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="text-theme-muted text-[12px]">Loading market trend data...</p>
                    </div>
                </div>
            ) : (
                seriesData.series.length > 0 && <MarketDummy selectedPeriod={selectedPeriod} onChange={handlePeriodChange} data={seriesData} periods={periods} />
            )}
        </div>
    );
}

export default MarketTrend;